import React, {memo} from "react";
import cn from "classnames";
import {IconRatingDelete, IconDeleteClose} from "../icons";
import {Preloader} from "../Preloader";

const ButtonDelete = memo(
  ({
    addClass,
    name,
    onClick,
    isWhite,
    disabled,
    color,
    activeOnHover,
    loading,
    ...props
  }) => {
    return loading ? (
      <Preloader size="small" addClass="hght-20" />
    ) : (
      <button
        name={name}
        className={cn(
          "btn-custom__delete",
          {[addClass]: !!addClass},
          {"active-on-hover": !!activeOnHover}
        )}
        onClick={onClick}
        type="button"
        disabled={disabled}
        {...props}
      >
        {isWhite ? <IconDeleteClose /> : <IconRatingDelete color={color} />}
      </button>
    );
  }
);

export default ButtonDelete;
